import { environment } from "../../environments/environment";

export const CONSTANTS = {
    message: {
        INITIAL: 'Please enter search criteria and hit search button.',
        INTERNAL_ERROR: 'Oops Something went wrong..!',
        INTERNAL_SERVER_ERROR: 'Oops Internal Server error..!',
        NETWORK_ERROR: 'Oops! Connection/Network error..!'
    },

    errorCodes: {
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        NOT_FOUND_HTTP_EXCEPTION: 404,
        PERMISSION_DENIED: 404,
        METHOD_NOT_FOUND: 405,
        ALREADY_EXISTS: 406,
        DATABASE_INITIALIZATION_FAIL: 407,
        ERROR_CODE_VALIDATION_FAILED: 422,
        INVALID_DOMAIN: 433,
        TOKEN_EXPIRED: 466,
        TOKEN_REQUIRED: 477,
        INTERNAL_SERVER_ERROR: 500
    },
    
    baseImageUrl: environment.baseImageURL,
    appUrl: environment.appURL,
    notificationIcon: '../../assets/images/logo.png',
    dummyUser: './assets/images/dummy-image.jpg',
    usertypeObj:{
        student:'student',
        tutor:'Tutor'
    },
    tutorAboutUrl:'about-tutor',
    tutorSubjectsUrl:'subjects',
    tutorLanguagesUrl:'languages',
    tutorEducationUrl:'education',
    tutorExperienceUrl:'experience',
    tutorAvailibilityUrl:'availability',
    tutorRatPerHourUrl:'rate-per-hour',
    tutorSubmitUrl:'submit',
    videoTypes:['video/x-f4v',
         'video/x-matroska',
         'video/x-msvideo',
         'video/mp4',
         'video/webm',
         'audio/webm',
         'video/3gpp',
         'audio/3gpp',
         'video/3gpp2',
         'audio/3gpp2',
         'video/x-ms-wmv',
         'video/quicktime',
         'video/MP2T',
         'video/x-flv'],
    digreeListObjArray:[
        {name:'Bachelor',value:'bachelor'},
        {name:'Master',value:'master'},
        {name:'Other',value:'other'},
    ],
    languagesListObjArray:[
        {name:'Basic',value:'Basic'},
        {name:'Conversational',value:'Conversational'},
        {name:'Fluent',value:'Fluent'},
        {name:'Native',value:'Native'},
    ],
    experienceTypeObjArray:[
        {name:'Full Time',value:'full_time'},
        {name:'Part Time',value:'part_time'},
    ],
    months: [
        { index: 1, name: 'January' },
        { index: 2, name: 'February' },
        { index: 3, name: 'March' },
        { index: 4, name: 'April' },
        { index: 5, name: 'May' },
        { index: 6, name: 'June' },
        { index: 7, name: 'July' },
        { index: 8, name: 'August' },
        { index: 9, name: 'September' },
        { index: 10, name: 'October' },
        { index: 11, name: 'November' },
        { index: 12, name: 'December' }
    ],

    days: [
        { index: 0, name: 'Monday' },
        { index: 1, name: 'Tuesday' },
        { index: 2, name: 'Wednesday' },
        { index: 3, name: 'Thursday' },
        { index: 4, name: 'Friday' },
        { index: 5, name: 'Saturday' },
        { index: 6, name: 'Sunday' },
    ],

    timeSlotZone:[
        {index:0,name:'00:00'},
        {index:1,name:'00:30'},
        {index:2,name:'01:00'},
        {index:3,name:'01:30'},
        {index:4,name:'02:00'},
        {index:5,name:'02:30'},
        {index:6,name:'03:00'},
        {index:7,name:'03:30'},
        {index:8,name:'04:00'},
        {index:9,name:'04:30'},
        {index:10,name:'05:00'},
        {index:11,name:'05:30'},
        {index:12,name:'06:00'},
        {index:13,name:'06:30'},
        {index:14,name:'07:00'},
        {index:15,name:'07:30'},
        {index:16,name:'08:00'},
        {index:17,name:'08:30'},
        {index:18,name:'09:00'},
        {index:19,name:'09:30'},
        {index:20,name:'10:00'},
        {index:21,name:'10:30'},
        {index:22,name:'11:00'},
        {index:23,name:'11:30'},
        {index:24,name:'12:00'},
        {index:25,name:'12:30'},
        {index:26,name:'13:00'},
        {index:27,name:'13:30'},
        {index:28,name:'14:00'},
        {index:29,name:'14:30'},
        {index:30,name:'15:00'},
        {index:31,name:'15:30'},
        {index:32,name:'16:00'},
        {index:33,name:'16:30'},
        {index:34,name:'17:00'},
        {index:35,name:'17:30'},
        {index:36,name:'18:00'},
        {index:37,name:'18:30'},
        {index:38,name:'19:00'},
        {index:39,name:'19:30'},
        {index:40,name:'20:00'},
        {index:41,name:'20:30'},
        {index:42,name:'21:00'},
        {index:43,name:'21:30'},
        {index:44,name:'22:00'},
        {index:45,name:'22:30'},
        {index:46,name:'23:00'},
        {index:47,name:'23:30'}
    ]
}